import { ObservableStore } from './observableStore';

export type RealtimeConnectionState =
  | { status: 'never-connected' }
  | { status: 'connected' }
  | { status: 'disconnected'; disconnectedSince: Date };

const NEVER_CONNECTED: RealtimeConnectionState = { status: 'never-connected' };
const CONNECTED: RealtimeConnectionState = { status: 'connected' };

export class ConnectionStateTracker extends ObservableStore<RealtimeConnectionState> {
  public constructor() {
    super(NEVER_CONNECTED);
  }

  public static get neverConnectedSnapshot(): RealtimeConnectionState {
    return NEVER_CONNECTED;
  }

  public markDisconnected(): void {
    if (this.getSnapshot().status !== 'disconnected') {
      this.replace({ status: 'disconnected', disconnectedSince: new Date() });
    }
  }

  public markConnected(): void {
    this.replace(CONNECTED);
  }

  public dispose(): void {
    this.clearListeners();
  }
}
